import { dehydrate, QueryClient } from 'react-query';
import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/urls';
import { IArticleByGroupDetail } from 'src/interface/ArticleByGroup';
import { ICategoryByGroupDetail } from 'src/interface/CategoryByGroup';
import wrapper from 'src/redux';
import { actionGetArticleByCategorySlug } from 'src/redux/actions/articleByGroup';

const HeadC = dynamic(() => import('src/components/Head'));
const ArticleDetailContainer = dynamic(() => import('src/containers/ArticlesDetail/index'));
const NewsArticleJsonLdC = dynamic(() => import('src/components/Layout/JsonLd/NewsArticle'));
const BreadCrumbJsonLd = dynamic(() => import('src/components/Layout/JsonLd/Breadcrumb'));
const JoinKomunitasDetailArtikelContainer = dynamic(
	() => import('src/containers/JoinKomunitasDetailArtikel'),
);

const SubCategoryPage = (props: any) => {
	const kehamilan = props.artikel;
	const metaTitle = !kehamilan.meta_title ? kehamilan.title : kehamilan.meta_title;
	const metaDescription = !kehamilan.meta_description
		? kehamilan.short_desc
		: kehamilan.meta_description;

	return (
		<>
			<HeadC title={metaTitle} description={metaDescription} pageItem={kehamilan} />
			<ArticleDetailContainer {...props} />
			<JoinKomunitasDetailArtikelContainer {...props} />

			<NewsArticleJsonLdC article={kehamilan} />
			<BreadCrumbJsonLd pageHeaderContent={props.pageHeaderContent} />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store: any) => async (ctx: any) => {
		let isError: boolean = false;
		let artikel: any = {};
		let dataComments: any = [];
		let artikelLainnya: any = [];
		const queryClient = new QueryClient();
		const query = ctx.params;
		const subCategorySlug = query.sub;

		try {
			artikel = await store.dispatch(await actionGetArticleByCategorySlug(subCategorySlug));
			const filters = 'order=asc&orderby=total_like';
			const urlC = `${g.API_ARTICLE_SLUG}/articles/${artikel.data.record.uid}/comments?${filters}`;
			const optionsComments = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};
			const dc = await fetch(urlC, optionsComments);
			dataComments = await dc.json().then((res) => ({ ...res, status: dc.status }));

			const url = `${g.API_ARTICLE}/pregnancy?${filters}&per_page=3&page=1`;
			const opts = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const artLainnya = await fetch(url, opts);
			artikelLainnya = await artLainnya
				.json()
				.then((res) => ({ ...res, status: artLainnya.status }));
		} catch (err: any) {
			if (err?.status === 400) {
				isError = true;
			} else {
				throw err;
			}
		}
		const subCategories: ICategoryByGroupDetail[] = store.getState().categoryByGroup.subCategories;
		const category = subCategories.find(
			(sc) => sc.slug === subCategorySlug,
		) as ICategoryByGroupDetail;

		const article: IArticleByGroupDetail[] =
			store.getState().articleByGroup.articleByCategory?.data?.records;

		if ((!category || !article) && isError) return { notFound: true };
		return {
			props: {
				dehydratedState: dehydrate(queryClient),
				card: true,
				isWhiteBackground: false,
				JsonLd: {
					organization: true,
					breadcrumbs: true,
				},
				pageHeaderContent: {
					title: 'kehamilan',
					breadcrumbs: [
						{ label: 'Artikel', navigatePath: '/artikel' },
						{ label: 'Kehamilan', navigatePath: '/kehamilan' },
						{ label: artikel.data.record.title },
					],
				},
				artikel: artikel.data.record || {},
				artikelLainnya: artikelLainnya.data.records || [],
				dataComments: dataComments.data.records || [],
			},
		};
	},
);

export default SubCategoryPage;
